import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@material-ui/core';

/**
 * TextArea field for MCP Catalog form with onBlur validation support.
 * When the field is required and loses focus with empty value,
 * it triggers validation to show the error message inline.
 */
function McpCatalogTextAreaField({ name, label, required }) {
    const { control, errors, trigger } = useFormContext();

    let isError = false;
    let errorMessage = '';
    if (errors && errors.hasOwnProperty(name)) {
        isError = true;
        errorMessage = errors[name].message;
    }

    const handleBlur = () => {
        trigger(name);
    };

    return (
        <div className="form-addTicket">
            <label className="form-addTicket-label">
                {label}
                {required && <span className="required">*</span>}
            </label>
            <div className="form-addTicket-input">
                <Controller
                    name={name}
                    control={control}
                    defaultValue=""
                    render={({ value, onChange }) => (
                        <TextField
                            value={value || ''}
                            multiline
                            rows={3}
                            rowsMax={6}
                            onChange={(e) => onChange(e.target.value)}
                            onBlur={handleBlur}
                            error={isError}
                            helperText={errorMessage}
                            className="form-control form-control-wrapTextarea form-control-hg112"
                            variant="outlined"
                            autoComplete="off"
                        />
                    )}
                />
            </div>
        </div>
    );
}

McpCatalogTextAreaField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool
};

McpCatalogTextAreaField.defaultProps = {
    required: false
};

export default McpCatalogTextAreaField;
